import {
  SET_QUIZ_ID,
  SET_QUIZ,
  SET_QUIZ_DURATION,
  SET_ALL_QUESTIONS,
  SET_EASY_QUESTIONS,
  SET_MEDIUM_QUESITONS,
  SET_HARD_QUESTIONS,
  SET_TECKET,
  SET_DURATION,
  SET_LEADER_BOARD_DATA,
  ANSWERED_QUESTIONS_COUNT,
  SET_MAX_ANSWER,
  LAST_QUESTION_ID,
  RENDER_LOADING,
  FINALIZE_QUIZ,
  SET_FINALIZE_REPORT,
  LOADING_FETCH_LB_DATA,
  LOADING_QUIZ_REQUESTS,
  SET_QUESTION_DATA,
  QUESTION_ANSWER,
  QUESTION_ANSWERED,
  SHOW_FINALIZE_MODAL,
  SHOW_CHEAT_MODAL,
  SET_WRONG_ANSWERS,
  SET_RIGHT_ANSWER,
  SET_SHOW_WORD_GAME_HINT_MODAL
} from "../../constants/ActionTypes";

const INIT_STATE = {
  loadingQuizReq: false,
  quizId: "",
  quiz: null,
  quizDuration: 0,
  currentQuestion: null,
  wrongAnswers: null,
  rightAnswer: null,
  allQuestions: null,
  easyQuestions: null,
  mediumQuestions: null,
  hardQuestions: null,
  ticket: null,
  duration: 0,
  LBFetchLoading: false,
  leaderBoardData: null,
  answeredQuestionsCount: 0,
  max_answer: 0,
  lastQuestionId: "",
  renderLoading: false,
  finalize: false,
  finalizeReport: null,
  questionAnswer: null,
  answeredQuestion: null,
  showFinalizeModal: false,
  showCheatModal: false,
  showWordGamehintModal: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOADING_QUIZ_REQUESTS: {
      return { ...state, loadingQuizReq: action.payload };
    }
    case SET_QUIZ_ID: {
      return { ...state, quizId: action.payload };
    }
    case SET_QUIZ: {
      return { ...state, quiz: action.payload };
    }
    case SET_QUESTION_DATA: {
      return { ...state, currentQuestion: action.payload };
    }
    case QUESTION_ANSWER: {
      return { ...state, questionAnswer: action.payload };
    }
    case SET_QUIZ_DURATION: {
      return { ...state, quizDuration: action.payload };
    }
    case SET_ALL_QUESTIONS: {
      return { ...state, allQuestions: action.payload };
    }
    case SET_EASY_QUESTIONS: {
      return { ...state, easyQuestions: action.payload };
    }
    case SET_MEDIUM_QUESITONS: {
      return { ...state, mediumQuestions: action.payload };
    }
    case SET_HARD_QUESTIONS: {
      return { ...state, hardQuestions: action.payload };
    }
    case SET_TECKET: {
      return { ...state, ticket: action.payload };
    }
    case SET_DURATION: {
      return { ...state, duration: action.payload };
    }
    case LOADING_FETCH_LB_DATA: {
      return { ...state, LBFetchLoading: action.payload };
    }
    case SET_LEADER_BOARD_DATA: {
      return { ...state, leaderBoardData: action.payload };
    }
    case ANSWERED_QUESTIONS_COUNT: {
      return { ...state, answeredQuestionsCount: action.payload };
    }
    case SET_MAX_ANSWER: {
      return { ...state, max_answer: action.payload };
    }
    case LAST_QUESTION_ID: {
      return { ...state, lastQuestionId: action.payload };
    }
    case RENDER_LOADING: {
      return { ...state, renderLoading: action.payload };
    }
    case FINALIZE_QUIZ: {
      return { ...state, finalize: action.payload };
    }
    case SET_FINALIZE_REPORT: {
      return { ...state, finalizeReport: action.payload };
    }
    case QUESTION_ANSWERED: {
      return { ...state, answeredQuestion: action.payload };
    }
    case SHOW_FINALIZE_MODAL: {
      return { ...state, showFinalizeModal: action.payload };
    }
    case SHOW_CHEAT_MODAL: {
      return { ...state, showCheatModal: action.payload };
    }
    case SET_WRONG_ANSWERS: {
      return { ...state, wrongAnswers: action.payload };
    }
    case SET_RIGHT_ANSWER: {
      return { ...state, rightAnswer: action.payload };
    }
    case SET_SHOW_WORD_GAME_HINT_MODAL: {
      return { ...state, showWordGamehintModal: action.payload };
    }
    default:
      return state;
  }
};
